export default {
  add_news: "Tambah Berita",
  edit_news: "Ubah Berita",
  detail_news: "Detail Berita",
  search_news: "Cari Berita",
  my_news: "Berita Saya"
};
